import ProfileContent from './ProfileContent';

export default ProfileContent;
